import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, ListGroup, Image, Form, Button, Card } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { FaTrash } from 'react-icons/fa';
import Message from '../components/Message';
import { removeFromCart, updateQty } from '../slices/cartSlice';

const CartScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { cartItems } = useSelector(state => state.cart);

  const removeFromCartHandler = (item) => {
    dispatch(removeFromCart({ productId: item._id, variant: item.variant  || {} }));
  };

  const checkoutHandler = () => {
    navigate('/login?redirect=/shipping');
  };

  const itemsCount = cartItems.reduce((acc, item) => acc + item.qty, 0);
  const totalPrice = cartItems.reduce((acc, item) => acc + (item.qty * (item.variant?.price || item.price)), 0).toFixed(2);

  return (
    <Row>
      <Col md={8}>
        <h1>Shopping Cart</h1>
        {cartItems.length === 0 ? (
          <Message>Your cart is empty <Link to="/">Go Back</Link></Message>
        ) : (
          <ListGroup variant="flush">
            {cartItems.map((item) => (
              <ListGroup.Item key={`${item._id}-${item.variant?.size}-${item.variant?.color}`}>
                <Row>
                  <Col md={2}>
                    <Image src={item.variant?.images?.[0] || item.image} alt={item.name} fluid rounded />
                  </Col>
                  <Col md={3}>
                    <Link to={`/product/${item._id}`}>{item.name}</Link>
                    {item.variant?.size && <div>Size: {item.variant.size}</div>}
                    {item.variant?.color && <div>Color: {item.variant.color}</div>}
                  </Col>
                  <Col md={2}>${item.variant?.price || item.price}</Col>
                 
                 
                 
                 <Col md={2}>
                 
                <Form.Select
  value={item.qty}
  onChange={(e) =>
    dispatch(
      updateQty({
        productId: item._id,
        variant: item.variant,
        qty: Number(e.target.value),
      })
    )
  }
>
  {[...Array(item.variant?.countInStock || 0).keys()].map((x) => (
    <option key={x + 1} value={x + 1}>
      {x + 1}
    </option>
  ))}
</Form.Select>
                 
                 
                 
                  </Col>
                  <Col md={2}>
                    <Button
                      type="button"
                      variant="light"
                      onClick={() => removeFromCartHandler(item)}
                    >
                      <FaTrash />
                    </Button>
                  </Col>
                </Row>
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
      </Col>

      <Col md={4}>
        <Card>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h2>Subtotal ({itemsCount}) {itemsCount === 1 ? 'item' : 'items'}</h2>
              <strong>${totalPrice}</strong>
            </ListGroup.Item>
            <ListGroup.Item>
              <Button
                type="button"
                className="w-100"
                disabled={cartItems.length === 0}
                onClick={checkoutHandler}
              >
                Proceed To Checkout
              </Button>
            </ListGroup.Item>
          </ListGroup>
        </Card>
      </Col>
    </Row>
  );
};

export default CartScreen;